import React from 'react';

const shopTypes = [
    {
        type: 'None',
        value: 'none'
    },
    {
        type: 'Custom',
        value: 'custom'
    },
    {
        type: 'Abilis',
        value: 'abilis'
    },
    {
        type: 'Quatron',
        value: 'quatron'
    }
];

export class ShopDropDownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    generateDropDown = () => {
        switch (this.props.dropDownType) {
            case 'add':
                return (
                    <select onChange={this.props.handler} name="dropDownAdd" id="dropDownMenuAdd" defaultValue="">
                        <option value="">{this.props.placeholder}</option>
                        {shopTypes.map(shopType => (
                            <option key={shopType.value} value={shopType.value}>
                                {shopType.type}
                            </option>
                        ))}
                    </select>
                );
            case 'edit':
                return (
                    <select onChange={this.props.handler} name="dropDownEdit" id="dropDownMenuEdit" value={this.props.shopType}>
                        <option value="">{this.props.placeholder}</option>
                        {shopTypes.map(shopType => {
                            return (
                                <option key={shopType.value} value={shopType.value}>
                                    {shopType.type}
                                </option>
                            );
                        })}
                    </select>
                );
            default:
            
        }
    };

    render() {
        return (
            <div className={`formDropDownShop ${this.props.extraClasses}`}>
                <label> {this.props.label} </label>
                <div className="dropDownWrapper">{this.generateDropDown()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/components/ShopDropDownMenu.js